import * as React from "react";
import { cn } from "../../../../helpers";
import styles from "./DirectionIcon.module.scss";

interface DirectionIconProps {
    direction?: string | null;
}

export default function DirectionIcon({ direction }: DirectionIconProps) {
    const normalizedDirection = direction?.toLowerCase();
    const isInbound = ["inbound", "incoming"].includes(normalizedDirection ?? "");
    const isOutbound = ["outbound", "outgoing"].includes(normalizedDirection ?? "");
    if (!isInbound && !isOutbound) {
        return null;
    }

    const label = isInbound ? "Incoming" : "Outgoing";

    return (
        <span
            className={cn(
                styles.directionIcon,
                styles[isInbound ? "inbound" : "outbound"]
            )}
            role="img"
            aria-label={label}
            title={label}
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                {isInbound ? (
                    <>
                        <line x1="19" y1="5" x2="5" y2="19" />
                        <polyline points="5 9 5 19 15 19" />
                    </>
                ) : (
                    <>
                        <line x1="5" y1="19" x2="19" y2="5" />
                        <polyline points="9 5 19 5 19 15" />
                    </>
                )}
            </svg>
        </span>
    );
}
